import React from 'react';

import usePrimaryContactU16 from './UsePrimaryContactU16';
import PrimaryContactForm from '../PrimaryContactInfoForm';

import NavLinks from '../../../NavLinks';
import Views from '../../../Views';
import ViewTemplate from '../../../components/viewTemplate/ViewTemplate';
import AddressBook from '../../../components/AddressBook/AddressBook';

import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';

import style from '../../Omr.module.css';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

const PrimaryContactU16 = () => {
  const {
    formState,
    errorState,
    onFormValueChanged,
    onValueTextPairChanged,
    onCountryChanged,
    setFormData,
    onBackButtonClicked,
    onNextButtonClicked,
    validateState,
    isCountryUSA,
    isCountryMexico,
    isCountryCanada,
    onActionIntraPageButtonClicked,
  } = usePrimaryContactU16();

  function onActionIntraPageButtonClickedProxy() {
    onActionIntraPageButtonClicked();
    formState.showedAddressSuggestion = true;
  }

  return (
    <ViewTemplate
      viewName={Views.PRIMARY_CONTACT_U16}
      onBackButtonClicked={onBackButtonClicked}
      onNextButtonClicked={onNextButtonClicked}>
      {validateState.isValidating === true && (
        <PopUpModal
          displayPopUp={true}
          maxWidth={250}
          title="Validating..."
          widthPct={50} />
      )}
      <AddressBook navlink={NavLinks.PRIMARY_CONTACT_INFO_U16} />
      <PrimaryContactForm
        formState={formState}
        errorState={errorState}
        onFormValueChanged={onFormValueChanged}
        onValueTextPairChanged={onValueTextPairChanged}
        setFormData={setFormData}
        onCountryChanged={onCountryChanged}
        isCountryUSA={isCountryUSA}
        isCountryMexico={isCountryMexico}
        isCountryCanada={isCountryCanada} />
      {/* <div className={style.AddMoreContactsButton}>
        <ActionIntraPageButton
          onClick={onActionIntraPageButtonClickedProxy}>Add More Contacts
        </ActionIntraPageButton>
      </div> */}
    </ViewTemplate>
  );
};

export default PrimaryContactU16;